/**
 * Normalizes a URL (path or full URL) for in-app vs full-page navigation.
 * Use the returned path with React Router (navigate/Link) to avoid full reloads;
 * use fullUrl for external links (window.location.href or <a href>).
 *
 * @param resolvedUrl - Already-prefixed path (e.g. from getPrefixedRoute) or a full URL
 * @returns path: for React Router when !isExternal; fullUrl: for href when isExternal
 */
export function getNavigationTarget(resolvedUrl: string): {
  path: string;
  isExternal: boolean;
  fullUrl: string;
} {
  const stripHash = (s: string) => s.replace('#', '');
  const isFullUrl = resolvedUrl.startsWith('http://') || resolvedUrl.startsWith('https://');
  const sameOrigin = isFullUrl && resolvedUrl.startsWith(window.location.origin);

  if (!isFullUrl) {
    return { path: stripHash(resolvedUrl), isExternal: false, fullUrl: resolvedUrl };
  }
  if (sameOrigin) {
    const path = (resolvedUrl.slice(window.location.origin.length) || '/').replace('#', '');
    return { path, isExternal: false, fullUrl: resolvedUrl };
  }
  return { path: '', isExternal: true, fullUrl: resolvedUrl };
}
